import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardHeader,
  FileInput,
  FileInputExtendedProps,
  Form,
  FormField,
  Select,
  TextInput,
  Text,
  CheckBox,
  Image,
  RadioButton
} from "grommet";
import { useLocation } from "react-router-dom";
import usersService from "../Users/users.service";
import CreateOrganization from "../Users/CreateOrganization/CreateOrganization";
import createFlightService from "../Users/CreateFlight/create-flight.service";
import { OrganizationType } from "../Users/types/OrganizationType";
import { observer } from "mobx-react";
import { useStore } from "../../../../../../Hooks/useStore";
import { useUser } from "../../../../context/User/UserContext";
import './EditProfile.css';
import camera from '../../../../../../assets/camera.svg'
import { Storage } from "aws-amplify";
import awsmobile from "../../../../../../aws-exports";
import Amplify from "aws-amplify";
import { APIs } from "../../../../../../util/api/APIs";
import SafeairManager from "../../../../../../util/api/SafeairManager";
import { AxiosError } from "axios";
Amplify.configure(awsmobile);
interface UserProfile {
  username: string;
  email: string;
  name: string;
  familyName: string;
  customType: string;
  organizationId: number;
  phoneNumber: string;
  gender: string;
}

type Subscription = {
  startDate: string | null;
  endDate: string | null;
  status: string;
  createdBy?: string;
  active?: boolean;
};

const EditProfile = () => {
  const { rootStore } = useStore();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const username = searchParams.get("username");
  const { user } = useUser();
  const [fileToUpload, setFileToUpload] = useState<Blob | null>(null);
  const [enableToggleValue, setEnableToggleValue] = useState(false)
  const [orgId, setOrgId] = useState(null);
  const [subscription, setSubscription] = useState<Subscription | null>(null);
  const [subscriptionError, setSubscriptionError] = useState(false);

  console.log("User object:", orgId);



  useEffect(() => {
    rootStore.editProfileStore.setProfile({
      enableNotification: enableToggleValue ? "on" : "off"
    });
  }, [enableToggleValue]);
  useEffect(() => {
    setEnableToggleValue(rootStore.editProfileStore.getProfile.enableNotification === 'on' ? true : false)
  }, [rootStore.editProfileStore.getProfile.enableNotification])

  const handleToggleChange = () => {
    setEnableToggleValue(!enableToggleValue);
  };

  // ----------------- VALIDATION -----------------
  const validateProfile = () => {
    const { name, familyName } = rootStore.editProfileStore.getProfile;

    if (!name || name.trim() === "") {
      rootStore.notificationToastStore.showNotification("First Name is required", true, 3000);
      return false;
    }
    if (!/^[a-zA-Z\s]+$/.test(name)) {
      rootStore.notificationToastStore.showNotification("First Name can only contain letters and spaces", true, 3000);
      return false;
    }
    if (name.length > 100) {
      rootStore.notificationToastStore.showNotification("First Name cannot exceed 100 characters", true, 3000);
      return false;
    }

    if (!familyName || familyName.trim() === "") {
      rootStore.notificationToastStore.showNotification("Last Name is required", true, 3000);
      return false;
    }
    if (!/^[a-zA-Z\s]+$/.test(familyName)) {
      rootStore.notificationToastStore.showNotification("Last Name can only contain letters and spaces", true, 3000);
      return false;
    }
    if (familyName.length > 100) {
      rootStore.notificationToastStore.showNotification("Last Name cannot exceed 100 characters", true, 3000);
      return false;
    }

    return true;
  };
  // ------------------------------------------------

  const getUserByUserName = async (uname: String) => {
    let user = await usersService.listUsersByUsername(uname.toString());
    const isApprovedSuperAdmin = user[0]["custom:isApprovedSuperAdmin"];
    let username = user[0].username ?? "";
    let fieldconfirm = "false";
    let userRoles = await usersService.getUserRoles(username);
    if (userRoles.length) {
      userRoles.map((role: any) => {
        if (role.code == "SuperAdmin") {
          fieldconfirm = "true";
        }
      });
    }
    rootStore.editProfileStore.setProfile({
      username: user[0].username ?? "",
      email: user[0].email ?? "",
      name: user[0].name ?? "",
      familyName: user[0].family_name ?? "",
      customType: user[0]["custom:type"] ?? "",
      phoneNumber: '2346234',
      gender: user[0].gender ?? "",
      showfield: fieldconfirm,
      isApproved: isApprovedSuperAdmin,
      enableNotification: user[0]["custom:enableNotification"] ?? "",
    });


  }

  const onSubmit = async () => {
    if (!validateProfile()) return; // 🔒 Block submission if invalid
    rootStore.loadingStore.setShowLoader(true)
    const { isApproved, showfield, ...profileupdate } = rootStore.editProfileStore.getProfile;
    if (username && rootStore.editProfileStore.getInitialOrg !== rootStore.editProfileStore.getSelectedOrg) {
      createFlightService.updateOrganizations(username, rootStore.editProfileStore.getSelectedOrg.toString())
    }
    await usersService.updateUserByAdmin(profileupdate);
    if (user) {
      if (rootStore.editProfileStore.getProfile.showfield === "true" && (user.email == "huseinattarwala@skalillc.com" || user.email == "ayushree.w@catalystmi.com")) {
        await usersService.updateConfirmStatus(rootStore.editProfileStore.getProfile.isApproved, rootStore.editProfileStore.getProfile.username);
      }
    }
    if (fileToUpload && username) {
      await uploadFile(fileToUpload, username);
    } else if (!username) {
      console.log("roomId is null")
    }
    rootStore.loadingStore.setShowLoader(false)
    rootStore.notificationToastStore.showNotification("Profile Update Successfully.", false, 3000);
  }

  useEffect(() => {
    if (username) {

      getUserByUserName(username);
      (async () => {
        let userOrg = await createFlightService.getOrgByUserName(username);
        setOrgId(userOrg.id)
        rootStore.editProfileStore.setSelectedOrd(userOrg.id);
        rootStore.editProfileStore.setInitialOrd(userOrg.id);
      })();
    }
    (async () => {
      let organizations = await createFlightService.getOrganizations();
      rootStore.editProfileStore.setOrganizationList(organizations);
    })();
  }, []);

  const handleGenderChange = (event: any) => {
    rootStore.editProfileStore.setProfile({
      gender: event.target.value
    })
  }

  const handleapproveChange = (event: any) => {
    rootStore.editProfileStore.setProfile({
      isApproved: event.target.value
    });
  }



  //subscription


  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        const result = await SafeairManager.getSubscriptionByOrgId({
          api: APIs.Form.getSubscriptionByOrgId,
          parameters: { orgId },
        });
  
        console.log("Fetched subscription:", result);
        setSubscription(result);
      } catch (err) {
        const error = err as AxiosError<any>; // cast to AxiosError
  
        console.error("Failed to fetch subscription:", error);
  
        const message = error?.response?.data?.errorMessage;
  
        if (
          error?.response?.status === 400 &&
          message?.includes("Subscription for this organization does not exist")
        ) {
          setSubscriptionError(true);
        }
      }
    };
  
    if (orgId) {
      fetchSubscription();
    }
  }, [orgId]);
  

  const formatDate = (dateStr: string): string => {
    if (!dateStr) return "";
    const [day, month, year] = dateStr.split("/");
    return `${day}/${month}/${year}`;
  };

  // Determine values to show
  const startDate = subscription?.startDate ? formatDate(subscription.startDate) : "";
const endDate = subscription?.endDate ? formatDate(subscription.endDate) : "";
const status = subscription?.status || "";
const renewedDate = ""; // Always blank
  


  ///subscription



  const CUSTOM_TYPE_OPTIONS = [
    {
      label: "Crew",
      value: "crew",
    },
    {
      label: "EMS",
      value: "ems",
    },
    {
      label: "Captain",
      value: "captain",
    },
    {
      label: "Admin",
      value: "admin",
    },
    {
      label: "Super Admin ",
      value: "superAdmin",
    },
    {
      label: "Coordinator",
      value: "coordinator",
    },
    {
      label: "Dispatch",
      value: "dispatch",
    },
  ];

  const CUSTOM_TYPE_OPTIONS_SECOND = [
    {
      label: "Crew",
      value: "crew",
    },
    {
      label: "EMS",
      value: "ems",
    },
    {
      label: "Captain",
      value: "captain",
    },
    {
      label: "Admin",
      value: "admin",
    },
    {
      label: "Coordinator",
      value: "coordinator",
    },
    {
      label: "Dispatch",
      value: "dispatch",
    },
  ];

  let userInfo;
  useEffect(() => {
    (
      async () => {
        userInfo = localStorage.getItem("userinfo");
        if (userInfo) {
          let roleLabel = JSON.parse(userInfo).roleLabel;
          rootStore.adminStore.handleRoleLabel(roleLabel);
          // getUserByUserName(JSON.parse(userInfo).username)
        }
      }
    )();
  }, [userInfo]);

  const GENDER_OPTIONS = [
    { label: "Select", value: "Select" },
    {
      label: "Male",
      value: "male",
    },
    {
      label: "Female",
      value: "female",
    },
    {
      label: "Others",
      value: "others",
    },
  ];

  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [imageSrc, setImageSrc] = useState<string>(rootStore.userStore.getProfileUrl);
  useEffect(() => {
    setImageSrc(rootStore.userStore.getProfileUrl)
  }, [rootStore.userStore.getProfileUrl])


  // Trigger the hidden file input when the box is clicked
  const handleBoxClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();  // Ensure fileInputRef.current is not null
    }
  };

  // Handle the file change event (i.e., when a user selects a new image)
  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      // Update the image source to the uploaded file's URL for preview
      const imageUrl = URL.createObjectURL(file);
      setImageSrc(imageUrl);  // Set the preview image

      // Convert the image URL to a Blob and set it for uploading
      const imageBlob = await urlToBlob(imageUrl);  // Await for the Blob
      setFileToUpload(imageBlob);  // Set the Blob for uploading
    }
  };
  const urlToBlob = async (imageUrl: string): Promise<Blob> => {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    return blob;
  };
  const uploadFile = async (file: File | Blob, roomId: string) => {
    const filePath = `profilePhotos/${roomId}/profile.png`;
    const currentUrl = window.location.href;
    let region = 'us-east-2'; // Default region
    let bucket = 'skali-report';
    // Check if the URL contains "localhost" or "sbx" to decide region
    if (currentUrl.includes('localhost') || currentUrl.includes('sbx')) {
      region = 'us-west-1';  // Set region to us-west-1 for localhost or sbx
      bucket = 'sbx-skali-report';
    }
    try {
      // Upload the file to S3
      await Storage.put(filePath, file, {
        bucket: bucket,
        region: region,
        contentType: 'image/jpeg',
        progressCallback: (progress: any) => {
          console.log('Upload progress:', progress);
        },
      } as any);
      console.log('File uploaded successfully');
      const uploadedFile = await getImage(filePath);
      if (uploadedFile) {
        rootStore.userStore.setProfileUrl(uploadedFile)
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      throw error;
    }
  };
  const getImage = async (filePath: string) => {
    const currentUrl = window.location.href;
    let region = 'us-east-2'; // Default region
    let bucket = 'skali-report';
    // Check if the URL contains "localhost" or "sbx" to decide region
    if (currentUrl.includes('localhost') || currentUrl.includes('sbx')) {
      region = 'us-west-1';  // Set region to us-west-1 for localhost or sbx
      bucket = 'sbx-skali-report';
    }
    try {
      const fileUrl = await Storage.get(filePath, {
        bucket: bucket,
        region: region,
        level: 'public', // Adjust access level if needed
        expires: 604799
      });

      const response = await fetch(fileUrl);

      if (response.ok && response.headers.get('Content-Type')?.startsWith('image/')) {
        // If it's an image, set the image source
        const messageContent = fileUrl.split('?')[0];
        setImageSrc(fileUrl); // Only set if it's a valid image
        return messageContent;
      } else {
        console.error('No valid image found at the URL:', fileUrl);
        return null; // Return null or handle the case where the image does not exist
      }
    } catch (error) {
      console.error('Error fetching image:', error);
      return null; // Return null or handle the error gracefully
    }
  };
  // useEffect(()=>{
  // //  const img = getImage(`profilePhotos/${username}/profile.png`)
  // },[])



  return (
    <Box className="create-user-container" style={{ backgroundColor: 'white' }}>
      <Card pad="medium" gap="medium">
        <p className="message-text" style={{ textAlign: 'start', fontWeight: '600', marginTop: "-11px", marginLeft: "-11px", height: "20px", fontSize: "16px", lineHeight: "20px", color: "#4B628A" }}>Your Profile</p>
        <Form
          validate="change"
          className="edit-profile-modal-form"
        >

          <Box align="start" onClick={handleBoxClick} style={{
            width: "100px",
            height: "100px",
            borderRadius: "full",
            overflow: "hidden",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "10px",
            position: "relative"
          }}>
            <Image
              src={imageSrc}
              fit="cover"
              style={{ borderRadius: '50%', width: "100px", height: '100px', objectFit: 'cover' }}
            />
            <Box
              style={{
                borderRadius: '35px', width: '32px', height: '32px', objectFit: "cover", position: "absolute", right: '2px', bottom: '4px', backgroundColor: 'white', alignItems: "center", justifyContent: "center"
              }}
            >
              <Image src={camera}
                alt="Camera svg"
                style={{ borderRadius: '50%', width: '20px', height: '20px', objectFit: "cover", color: 'blue' }}
              />
            </Box>
            {/* Hidden file input */}
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: 'none' }}
              accept="image/*"
              onChange={handleFileChange}
            />

          </Box>

          <Box style={{ width: '70%', display: "flex", gap: '20px', flexDirection: 'row' }}>

            <FormField name="password1" htmlFor="textinput" className="edit-profile-modal-form-F1"
              style={{ width: "45%" }}
            >
              {/* <TextInput
              placeholder="username"
              id="textinput"
              name="password1"
              type="text"
              value={rootStore.editProfileStore.getProfile?.username}
              disabled={true}
            /> */}
              <label className="edit-profile-modal-form-L1">Username</label>
              <TextInput
                style={{ width: "100%" }}
                className="edit-profile-modal-form-I1"
                placeholder="Username"
                id="textinput"
                name="password1"
                value={rootStore.editProfileStore.getProfile?.username}
                disabled={true}
              />
            </FormField>

            <FormField
              className="edit-profile-modal-form-F6"
              style={{ width: "45%" }}
            // required
            >
              <label className="edit-profile-modal-form-L1">Gender</label>
              <div className="edit-profile-modal-form-S1">
                <Select
                  style={{ width: '100%', fontSize: "15px" }}
                  className="edit-profile-modal-form-S1"
                  name="profile"
                  labelKey={"label"}
                  valueKey={{ key: "value", reduce: true }}
                  options={GENDER_OPTIONS}
                  defaultValue={"Select"}
                  required
                  value={rootStore.editProfileStore.getProfile?.gender}
                  onChange={(e) => { handleGenderChange(e) }}
                />
              </div>
            </FormField>
          </Box>


          {/* <FormField name="email" htmlFor="textinput">
            <TextInput
              placeholder="email"
              id="textinput"
              name="email"
              type="email"
              value={rootStore.editProfileStore.getProfile.email}
              onChange={(event) => {
                rootStore.editProfileStore.setProfile({
                  email: event.target.value
                })
              }}
            />
          </FormField> */}

          <Box style={{ width: '70%', display: "flex", gap: '20px', flexDirection: 'row' }}>
            <FormField 
              name="name" 
              htmlFor="textinput" 
              className="edit-profile-modal-form-F1"
              style={{ width: "45%" }}
              required
              validate={[
                (value: string) => {
                  if (!value || value.trim() === "") return "First Name is required";
                  if (!/^[a-zA-Z\s'-]+$/.test(value)) return "Only letters, spaces, hyphens and apostrophes are allowed";
                  if (value.length > 100) return "Maximum 100 characters allowed";
                  return undefined;
                },
              ]}
            >
              <label className="edit-profile-modal-form-L1">First Name</label>
              <TextInput
                style={{ width: "100%" }}
                className="edit-profile-modal-form-I3"
                placeholder="name"
                id="textinput"
                name="name"
                type="text"
                maxLength={100}
                value={rootStore.editProfileStore.getProfile.name}
                onChange={(event) => {
                  rootStore.editProfileStore.setProfile({
                    name: event.target.value
                  })
                }}
              />
            </FormField>

            <FormField 
              name="lname" 
              htmlFor="textinput" 
              className="edit-profile-modal-form-F1"
              style={{ width: '45%' }}
              required
              validate={[
                (value: string) => {
                  if (!value || value.trim() === "") return "Last Name is required";
                  if (!/^[a-zA-Z\s'-]+$/.test(value)) return "Only letters, spaces, hyphens and apostrophes are allowed";
                  if (value.length > 100) return "Maximum 100 characters allowed";
                  return undefined;
                },
              ]}
            >
              <label className="edit-profile-modal-form-L1">Last Name</label>
              <TextInput
                style={{ width: "100%" }}
                className="edit-profile-modal-form-I4"
                placeholder="last name"
                id="textinput"
                name="lname"
                type="text"
                maxLength={100}
                value={rootStore.editProfileStore.getProfile.familyName}
                onChange={(event) => {
                  rootStore.editProfileStore.setProfile({
                    familyName: event.target.value
                  })
                }}
              />
            </FormField>
          </Box>

          {user && rootStore.adminStore.getRoleName.toLowerCase() === "admin" && (


<Box
background="white"
pad="large"
round="medium"
elevation="medium"
margin={{ top: "large" }}
style={{
  width: "100%",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
  border: "1px solid #e6e6e6",
}}
>
<Box
  border={{ side: "bottom", size: "xsmall", color: "light-4" }}
  pad={{ bottom: "small" }}
  margin={{ bottom: "medium" }}
>
  <h2
    style={{
      margin: 0,
      fontSize: "22px",
      color: "#2c3e50",
      fontWeight: 600,
      letterSpacing: "0.5px",
    }}
  >
    📝 Subscription Details
  </h2>
</Box>

<Box direction="row" gap="30px" wrap style={{ justifyContent: "flex-start" }}>
  {/* Subscription Status */}
  <Box style={{ width: "45%", marginBottom: "25px" }}>
    <label
      style={{
        fontWeight: 500,
        color: "#555",
        marginBottom: "8px",
        display: "block",
      }}
    >
      Subscription Status
    </label>
    <TextInput
      value={status}
      disabled
      style={{
        width: "100%",
        padding: "10px",
        backgroundColor: "#f5f5f5",
        border: "1px solid #ccc",
        borderRadius: "6px",
      }}
    />
  </Box>

  {/* Start Date */}
  <Box style={{ width: "45%", marginBottom: "25px" }}>
    <label
      style={{
        fontWeight: 500,
        color: "#555",
        marginBottom: "8px",
        display: "block",
      }}
    >
      Start Date
    </label>
    <TextInput
      value={startDate}
      disabled
      style={{
        width: "100%",
        padding: "10px",
        backgroundColor: "#f5f5f5",
        border: "1px solid #ccc",
        borderRadius: "6px",
      }}
    />
  </Box>

  {/* End Date */}
  <Box style={{ width: "45%", marginBottom: "25px" }}>
    <label
      style={{
        fontWeight: 500,
        color: "#555",
        marginBottom: "8px",
        display: "block",
      }}
    >
      End Date
    </label>
    <TextInput
      value={endDate}
      disabled
      style={{
        width: "100%",
        padding: "10px",
        backgroundColor: "#f5f5f5",
        border: "1px solid #ccc",
        borderRadius: "6px",
      }}
    />
  </Box>

  {/* Renewed Date (Always blank) */}
  {/* <Box style={{ width: "45%", marginBottom: "25px" }}>
    <label
      style={{
        fontWeight: 500,
        color: "#555",
        marginBottom: "8px",
        display: "block",
      }}
    >
      Renewed Date
    </label>
    <TextInput
      value={renewedDate}
      disabled
      style={{
        width: "100%",
        padding: "10px",
        backgroundColor: "#f5f5f5",
        border: "1px solid #ccc",
        borderRadius: "6px",
      }}
    />
  </Box> */}
</Box>
</Box>
)}



 



        <Box direction="row" align="center" pad="medium" gap="small" >
          <Text style={{
            color: "#4B628A",
            fontFamily: "Inter",
            fontSize: "15px",
            fontStyle: "normal",
            fontWeight: "500",
            lineHeight: "20px",
            marginLeft: "-2%"
          }}>
            Enable Notification
          </Text>
          <CheckBox
            toggle
            checked={enableToggleValue}
            onChange={handleToggleChange}
          />
        </Box>




        {/* <div className={rootStore.adminStore.getRoleName.toLowerCase() == "superadmin" ? "" : "edit-create-user-org"}>
            <Select
              name="organization"
              labelKey={"label"}
              valueKey={{ key: "value", reduce: true }}
              options={rootStore.editProfileStore.getOrganizationList.map((org) => {
                return {
                  label: org.name,
                  value: org.id,
                };
              })}
              value={rootStore.editProfileStore.getSelectedOrg}
              defaultValue={""}
              onChange={(event) => {
                rootStore.editProfileStore.setSelectedOrd(event.option.value);
              }}
            />
          </div> */}
        {/* <label style={{display: 'block',marginTop: 15}}>Gender :</label> */}
        {/* <Box style={{display: 'flex',flexDirection: 'row',marginTop: 10,marginBottom: 10}}>
            <RadioButton
              name="radioButtonGroup"
              label="Male"
              value="male"
              checked={rootStore.editProfileStore.getProfile.gender === "male"}
              onChange={handleGenderChange}
            />
            <Box margin={{ left: '20px' }}>
              <RadioButton
                name="radioButtonGroup"
                label="Female"
                value="female"
                checked={rootStore.editProfileStore.getProfile.gender === "female"}
                onChange={handleGenderChange}
              />
            </Box>
          </Box> */}

        {/* <FormField
            label="Profile"
            name="profile"
            htmlFor="textinput-id"
            required
          >
            <Select
              name="profile"
              labelKey={"label"}
              valueKey={{ key: "value", reduce: true }}
              options={rootStore.adminStore.getRoleName.toLowerCase() == "admin" ? CUSTOM_TYPE_OPTIONS_SECOND : CUSTOM_TYPE_OPTIONS}
              value={rootStore.editProfileStore.getProfile.customType}
              defaultValue={"crew"}
              onChange={(event) => {
                rootStore.editProfileStore.setProfile({                 
                  customType: event.target.value
                 
                });
              }}
            />
          </FormField> */}
        {
          (user && rootStore.editProfileStore.getProfile.showfield === "true" && (user.email == "huseinattarwala@skalillc.com" || user.email == "ayushree.w@catalystmi.com")) && (
            <>
              <label style={{ display: 'block', marginTop: 15 }}>Confirm User :</label>
              <Box style={{ display: 'flex', flexDirection: 'row', marginTop: 10, marginBottom: 10 }}>
                <RadioButton
                  name="confirmuser"
                  label="Yes"
                  value="true"
                  checked={rootStore.editProfileStore.getProfile.isApproved === "true"}
                  onChange={handleapproveChange}
                />
                <Box margin={{ left: '20px' }}>
                  <RadioButton
                    name="confirmuser"
                    label="No"
                    value="false"
                    checked={rootStore.editProfileStore.getProfile.isApproved == "false"}
                    onChange={handleapproveChange}
                  />
                </Box>
              </Box>
            </>
          )
        }

        <Box direction="row" gap="medium" pad={"medium"} justify="end">
          {/* <Button type="submit" primary label="Submit" onClick={onSubmit} color={"brand-1"} /> */}
          <Button
            label="Save"
            style={{
              display: "flex",
              width: "130px",
              padding: "5px 59px",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "8px",
              background: "#357EFF",
              color: "var(--all-colors-white-color-white, #FFF)",
              fontFamily: "Inter",
              fontSize: "15px",
              fontStyle: "normal",
              fontWeight: "600",
              lineHeight: "24px",
            }}
            type="submit"
            onClick={onSubmit}
          />
        </Box>
      </Form>
    </Card>
    </Box >
  );
}

export default observer(EditProfile);